/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Field extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            error: false,
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(update) {
        this.setState({ value: update.value });
    }

    onChange(evt) {
        const name = this.props.name;
        const value = evt.target.value;
        const error = this.props.validate ? this.props.validate(value) : false;

        this.setState({ value, error });
        this.props.onChange({ name, value, error });
    }

    render() {
        return (
          <div>
            <div className={this.props.className}>
                <input
                    placeholder={this.props.placeholder}
                    autoComplete={this.props.autocomplete}
                    value={this.state.value}
                    type={this.props.type}
                    autoFocus={this.props.autoFocus}
                    onChange={this.onChange}
                />
               {this.props.children}


            </div><span style={{ color: 'red' }}>{ this.state.error }</span>
          </div>
        )
    }
}

Field.PropTypes = {
    placeholder: PropTypes.string,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string,
    autocomplete: PropTypes.string,
    validate: PropTypes.func,
    onChange: PropTypes.func.isRequired
}

Field.defaultProps = {
    autoFocus: false,
    autocomplete: "ciao"
};

export default Field;



/** WEBPACK FOOTER **
 ** ./src/components/Field.jsx
 **/